import React from 'react'
import OrderStatusContainer from './components/OrderStatusContainer'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'

export default function app() {
    const qClient = new QueryClient();

    return (
        <div>
            <QueryClientProvider client={qClient}>
                <OrderStatusContainer />
            </QueryClientProvider>
        </div>
    )
}
